/*
  Import Sentry's node or Raven browser moudule depending on env

  Use process.env.BUILD_TARGET over @jetshop/core/inServer.
  
  When using `process.env.*` this is evaluated at compile time & only one
  of the lines will  transpiled into the final code.
*/
let report;
if (__IN_SERVER__) {
    report = require('./errorReporting.server').default;
}
else {
    report = require('./errorReporting.browser').default;
}
export default report;
//# sourceMappingURL=errorReporting.js.map